var map = {
	"./administration.png": 864,
	"./brand-logo.png": 865,
	"./dashboard.png": 866,
	"./help.png": 867,
	"./notifications.png": 868,
	"./time-and-attendance.png": 869,
	"./time-off-management.png": 870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;